<template>
  <div class="weui-cells weui-cells_form" style="background: white;">
    <h3 class="page__title">链点提现申请管理</h3>
    <div class="weui-cell weui-cell_active weui-cell_vcode" style="color: black;">
        <div class="weui-cell__hd">
            <label class="weui-label">处理状态</label>
        </div>
        <div class="weui-cell__bd weui-cell__bd-WU">
            <input class="weui-input" style="text-align:center" type="text" placeholder="0 待处理，1 处理完毕" v-model="state" />
        </div>
    </div>
    <div class="weui-cell weui-cell_active weui-cell_vcode" style="color: black">
        <div class="weui-cell__hd">
            <label class="weui-label">商户ID</label>
        </div>
        <div class="weui-cell__bd weui-cell__bd-WU">
            <input class="weui-input" style="text-align:center" type="text" placeholder="输入提现商户号" v-model="partnerid" />
        </div>
    </div>
    <div class="weui-cell weui-cell_active weui-cell_vcode" >
        <div class="weui-cell__hd">
        </div>
        <div class="weui-cell__bd">
          <a @click="getMyWithDrawRecord" class="weui-btn weui-btn_primary">查询</a>
        </div>
    </div>
    <div v-if="(recordsWithDraw != null) && (recordsWithDraw.length > 0)">
     <hr/>
      <table class="table table-striped " style="font-size: small;" >
            <thead>
               <td>申请时间</td>
               <td>商户号</td>
               <td>链点数量</td>
               <td>状态</td>
            </thead>
            <tbody style="padding: 0px;margin:0px">
              <tr v-for="rcd in recordsWithDraw" :key="rcd.id" @click="withDrawComplatePre(rcd)">
                <td>{{ rcd.createTime }}</td>
                <td>{{ rcd.withdrawAccount }}</td>
                <td>{{ rcd.withdrawAmount }}</td>
                <td @click="withDrawComplatePre(rcd)">{{ getRState(rcd.withdrawState) }}</td>
              </tr>
            </tbody>
            <tfoot>

            </tfoot>
          </table>
    </div>
    <div class="weui-mask" id="iosMaskDlg" style="display: none;" @click="hideDlg"></div>
    <div class="weui-actionsheet" id="curRecordDlg">
      <!--
        <div class="weui-actionsheet__title">
            <p class="weui-actionsheet__title-text">{{title}}</p>
        </div>
      -->
        <div class="weui-actionsheet__menu" v-if="curRecord != null">
          <table class="table table-striped " style="font-size: small;" >
            <tr><td>申请时间</td><td>{{ curRecord.createTime }}</td></tr>
            <tr><td>商户号</td><td>{{ curRecord.withdrawAccount }}</td></tr>
            <tr><td>账号名称</td><td>{{ curRecord.accountName }}</td></tr>
            <tr><td>链点数量</td><td>{{ curRecord.withdrawAmount }}</td></tr>
            <tr><td>银行</td><td>{{ curRecord.bankName }}</td></tr>
            <!-- <tr><td>城市</td><td>{{ curRecord.cityName }}</td></tr> -->
            <tr><td>支行</td><td>{{ curRecord.cityName }} {{ curRecord.bankBranch }}</td></tr>
            <tr><td>卡号</td><td>{{ curRecord.bankId }}</td></tr>
            <!--  --><tr><td>处理时间</td><td>{{ curRecord.modifyTime }}</td></tr>
            <tr><td>状态</td><td>{{ getRState(curRecord.withdrawState) }}</td></tr>
            <tr v-if="curRecord.withdrawState != 1 "><td>操作</td>
              <td><a class="weui-btn weui-btn_primary" @click="withDrawComplate(curRecord.withdrawId)">点此结单</a></td>
            </tr>
          </table>
        </div>
        <!--
        <div class="weui-actionsheet__action">
            <div class="weui-actionsheet__cell" id="iosActionsheetCancel">关闭</div>
        </div>
      -->
    </div>
  </div>
</template>

<style>
.a_hot_touch{color:blue;font-style:italic;text-decoration:underline;}
</style>

<script>

import axios from "axios"
import JQ from 'jquery'
import wx from 'jweixin-1.6.0';
import {getPoints,getWithDrawRecords} from '../graphql/api'

export default {
data () {
  return {
    ing:true,
    partnerid:"",
    state:null,
    recordsWithDraw:null,
    curRecord:null,
  }
},
mounted() {
     this.partnerid = sessionStorage.getItem("partnerid")

     this.getMyWithDrawRecord();
},
methods: {
  getMyWithDrawRecord(){
    let that = this
    let paras = {};

    paras.acc = /*(this.partnerid == "M2022060601") ? null: */this.partnerid ;
    paras.state = this.state;

    getWithDrawRecords(paras)
    // findAllWeChatAccDailyStatement(that.partnerid,{bd:"2022-12-01",ed:"2022-12-05 23:59:59",ls:[1,2],lt:[1,2,3,4]})
    .catch(err=>{
      console.log(err)
    })
    .then(res1=>{
     // alert(1)
      console.info('获取数据=》'+JSON.stringify(res1.data))
      //alert(JSON.stringify(res1.data))
      that.recordsWithDraw = res1.data.findAllWithdraw

    })
  },
  getRState(istate){if(istate == 1) return "成功"; return "处理中"},
  fenToCNY(fen){
    let prefix = "";
    let res= ""
    let intv = parseInt(fen)

    if(intv < 0) {
      intv = Math.abs(intv);
      prefix = "-";
    }

    if(intv <= 9){
      res = "0.0"+ ( intv).toString();
    }else if(intv <= 99){
      res =  "0."+ ( intv).toString();
    }else {
      res = intv.toString();

      res = res.substring(0,res.length-2) + "." + res.substring(res.length-2)
    }
    return prefix+res;

  },
  toDir(str) {
      this.$router.push({
        name: str /*,
        params: {
          dateStr: date,
          state: state,
          posid: 0
        }*/
      });
    },
    hideDlg(){
      JQ('#curRecordDlg').removeClass('weui-actionsheet_toggle up80px');
      JQ('#iosMaskDlg').fadeOut(200);
    },
    withDrawComplatePre(rcd){
      console.log(rcd)
      this.curRecord = rcd
      JQ('#curRecordDlg').addClass('weui-actionsheet_toggle up80px');
      JQ('#iosMaskDlg').fadeIn(200);
    },
    withDrawComplate(tid) {
    console.log("withDrawComplate")

    let that = this;
    axios.get('customer/omc/withdrawConfirm?withdrawId='+tid)
    .then(function (response) {
      console.log(response);
      if(response.data.retcode == 0){
        that.getMyWithDrawRecord();
      }else{
        alert(response.data.retmsg)
      }

      that.hideDlg()

    })
    .catch(function (error) {
      console.log(error);
    });
  }
 }
}
</script>

<style>
::-webkit-input-placeholder {
  color: gray;
}

:-moz-placeholder {
  color: gray;
}

::-moz-placeholder {
  color: gray;
}

:-ms-input-placeholder {
  color: gray;
}
</style>



// WEBPACK FOOTER //
// src/views/ld_deposit_apply_mgr.vue